module.exports = __webpack_public_path__ + "static/media/tag.7fa671d5.svg";